import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';
import SessionDetail from './SessionDetail';
import clients from '../../clients';
import locations from '../../locations';
import misc from '../../misc';

const SessionDetailToJS = misc.lib.toJS(SessionDetail);

class SessionDetailContainer extends Component {
  componentDidMount() {
    this.props.fetchClientsIfNeeded();
    this.props.fetchLocationsIfNeeded();
    this.props.fetchSessionsIfNeeded();
    this.props.setActive(this.props.match.params.id);
  }

  render() {
    const { ui } = this.props;
    return (
      <SessionDetailToJS
        session={this.props.session}
        allClients={this.props.allClients}
        allLocations={this.props.allLocations}
        isLoading={ui.get('isLoading')}
        isError={ui.get('isError')}
        errorMessage={ui.get('errorMessage')}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  session: selectors.getActive,
  ui: selectors.getUI,
  allClients: clients.selectors.getEntities,
  allLocations: locations.selectors.getEntities
});

export default connect(mapStateToProps, {
  ...actions,
  fetchClientsIfNeeded: clients.actions.fetchClientsIfNeeded,
  fetchLocationsIfNeeded: locations.actions.fetchLocationsIfNeeded
})(SessionDetailContainer);



// WEBPACK FOOTER //
// ./src/modules/sessions/components/SessionDetailContainer.js